import React, { useState } from "react";
import axios from "axios";
// import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_API_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await axios.post(
        `${API_URL}/api/auth/forgot-password`,
        { email },
        { withCredentials: true }
      );

      setMessage("✅ Password reset link sent to your email.");
      setEmail("");
    } catch (err) {
      setError(
        err.response?.data?.message || "❌ Server error. Please try again later."
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 to-purple-700 px-6 py-12">
      <form
        onSubmit={handleForgotPassword}
        className="bg-white rounded-xl shadow-2xl p-10 max-w-md w-full"
      >
        <h2 className="text-3xl font-extrabold mb-6 text-center text-gray-900 tracking-wide">
          Forgot Password
        </h2>

        <p className="text-center text-sm text-gray-600 mb-6">
          Enter your email and we’ll send you a password reset link.
        </p>

        {message && (
          <p className="mb-4 text-center text-green-700 bg-green-100 rounded-md py-2 px-4 font-medium">
            {message}
          </p>
        )}
        {error && (
          <p className="mb-4 text-center text-red-700 bg-red-100 rounded-md py-2 px-4 font-medium">
            {error}
          </p>
        )}

        <label className="block mb-2 font-semibold">Email</label>
        <input
          type="email"
          className="w-full p-3 border rounded-lg mb-6"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button
          type="submit"
          className="w-full bg-gradient-to-r from-blue-600 to-purple-700 text-white font-bold py-3 rounded-lg shadow-lg transition duration-300 hover:opacity-90"
        >
          Send Reset Link
        </button>

        <div className="mt-6 text-center text-sm">
          <a
            href="/login"
            className="text-blue-700 hover:underline font-medium"
          >
            ← Back to Login
          </a>
        </div>
      </form>
    </div>
  );
}
